import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Фоновая текстура на весь экран через position:fixed — надёжнее, чем CSS
        background-attachment:fixed, который многие мобильные webview (в т.ч. Telegram) игнорируют. */}
    <div
      className="fixed inset-0 -z-10 bg-cover bg-center opacity-[0.16] pointer-events-none"
      style={{ backgroundImage: 'url(/textures/marble.jpg)' }}
    />
    <App />
  </React.StrictMode>,
);
